import React from 'react';
interface LogoProps {
  className?: string;
  showWordmark?: boolean;
  layout?: 'horizontal' | 'vertical' | 'icon-only';
  size?: 'sm' | 'md' | 'lg' | 'xl';
  variant?: 'dark' | 'light';
}
export function Logo({
  className = '',
  showWordmark = true,
  layout = 'vertical',
  size = 'lg',
  variant = 'dark'
}: LogoProps) {
  // Size mapping
  const sizeClasses = {
    sm: 'h-8',
    md: 'h-12',
    lg: 'h-24',
    xl: 'h-40'
  };
  const containerSize = sizeClasses[size];
  // Colors based on variant
  const navy = variant === 'light' ? '#FAF8F5' : '#1A1A2E';
  const gold = '#C9A227';
  const textColor = variant === 'light' ? 'text-[#FAF8F5]' : 'text-[#1A1A2E]';
  return <div className={`flex ${layout === 'vertical' ? 'flex-col' : 'flex-row'} items-center justify-center gap-5 ${className}`} data-id="element-1">
      {/* Icon Mark */}
      <div className={`${containerSize} aspect-square flex items-center justify-center`} data-id="element-2">
        <svg viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-full" aria-label="Somethink Music Logo Mark" data-id="element-3">
          {/* Shape A (Top Left to Bottom Right flow) */}
          <path d="M30 25 L60 25 L50 45 L20 45 Z" fill={navy} data-id="element-4" />
          {/* Shape B (Bottom Left to Top Right flow) */}
          <path d="M20 55 L50 55 L60 75 L30 75 Z" fill={navy} data-id="element-5" />
          {/* Mirrored side */}
          <path d="M70 25 L40 25 L50 45 L80 45 Z" fill={navy} data-id="element-6" />
          <path d="M80 55 L50 55 L40 75 L70 75 Z" fill={navy} data-id="element-7" />
          {/* Center Gold Diamond */}
          <path d="M50 35 L60 50 L50 65 L40 50 Z" fill={gold} data-id="element-8" />
        </svg>
      </div>

      {/* Wordmark */}
      {(showWordmark || layout !== 'icon-only') && <div className={`text-center ${layout === 'horizontal' ? 'text-left' : 'mt-1'}`} data-id="element-9">
          <h1 className={`font-medium tracking-[0.25em] ${textColor} leading-none`} style={{
        fontSize: size === 'sm' ? '1rem' : size === 'md' ? '1.5rem' : size === 'lg' ? '2.25rem' : '3.5rem'
      }} data-id="element-10">
            SOMETHINK
          </h1>
          <p className="font-light tracking-[0.5em] text-[#C9A227] mt-2 uppercase" style={{
        fontSize: size === 'sm' ? '0.5rem' : size === 'md' ? '0.6rem' : size === 'lg' ? '0.75rem' : '1rem'
      }} data-id="element-11">
            Music
          </p>
        </div>}
    </div>;
}